/**
 * Moves sticky WhatsApp buttons to document.body so they sit above
 * footer, newsletter, and product card stacking contexts.
 */
(function () {
  const SELECTOR = '.ps-whatsapp-sticky';

  function portalButtons() {
    document.querySelectorAll(SELECTOR).forEach((button) => {
      if (button.parentElement === document.body) return;
      document.body.appendChild(button);
    });
  }

  function init() {
    portalButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
